import { useQuery } from '@tanstack/react-query';
import { Fragment, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOnboardingStore } from 'store/useOnboardingStore';
import useUserStore from 'store/useUserStore';
import { ROUTES } from 'util/Constants';

const SubscriptionSuccess = () => {
    const { fetchUser } = useUserStore();
    const { currentStep, setCurrentStep } = useOnboardingStore();
    const navigate = useNavigate();
    const hasIncremented = useRef(false);

    const { isSuccess, isError } = useQuery({
        queryKey: ['fetchUser'],
        queryFn: fetchUser,
        retry: 3,
        retryDelay: 1000,
        refetchOnWindowFocus: false,
    });

    useEffect(() => {
        if (isSuccess && !hasIncremented.current) {
            // Set the step to 2 (third step) since we're coming from payment
            setCurrentStep(2);
            hasIncremented.current = true;

            // Only redirect after step is set and user data is loaded
            setTimeout(() => {
                navigate(ROUTES.ONBOARDING);
            }, 1000);
        }
    }, [isSuccess, setCurrentStep, navigate]);

    if (isError) {
        return (
            <div className="flex flex-col items-center justify-center h-screen">
                <div className="text-red-500 mb-4">Failed to load user data</div>
                <button onClick={() => navigate(ROUTES.ONBOARDING)} className="px-4 py-2 bg-blue-500 text-white rounded">
                    Continue Anyway
                </button>
            </div>
        );
    }

    return (
        <Fragment>
            <div className="flex flex-col items-center justify-center h-screen">
                <div className="text-xl mb-4">Successfully Created Subscription Plan!</div>
                <div className="text-gray-600">Please wait while we load your account...</div>
            </div>
        </Fragment>
    );
};

export default SubscriptionSuccess;
